var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"field",attrs:{"label":_vm.label || _vm.$t('lines.search.types'),"items":_vm.items,"clearable":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }